import { ViewModel,View, ViewModelMessage } from "binder"
import { ElementDecorator, FormBuilderElement } from "../../element";
import { CompactView } from "./compact-view";
import  { ComponentSelectDecoratorView } from "./componentSelectDecorator-view"

export class ComponentSelectDecoratorViewModel extends ElementDecorator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.IsElementSelected = false;
        
    }
    GetDefaultView(): View <ViewModel> {
        return new ComponentSelectDecoratorView();
    }
    public getTypeId(): string {
        return "VM-9F7021C9-2F35-4D65-BD54-23B44F9900E6"
    }
    public set IsElementSelected(v: boolean) { this._IsElementSelected = v; } public get IsElementSelected(): boolean { return this._IsElementSelected;} private _IsElementSelected: boolean;

    decoratorClicked() {
        this.IsElementSelected = true;
        this.handleMessage(new FormBuilderElementSelectedMessage(this.decoratorHead));;
    }

    getCompactViewForFormBuilderStructureViewDecorators(vm){
        return new CompactView();
    }

    handleMessage(msg:ViewModelMessage){
        if(msg instanceof FormBuilderElementUnSelectMessage && msg.element.self==this.self){
            this.IsElementSelected = false;
            return null;
        }else{
            return super.handleMessage(msg);
        }
    }
}


export class FormBuilderElementSelectedMessage extends ViewModelMessage{
    constructor(element:FormBuilderElement) {
        super();
        this.element = element;
    }
    public element:FormBuilderElement;
}
export class FormBuilderElementUnSelectMessage extends ViewModelMessage{
    constructor(element:FormBuilderElement) {
        super();
        this.element = element;
    }
    public element:FormBuilderElement;
}
